import { useEffect, useState } from 'react';

import { fetchStudentsTestingResults } from '../../http/User_API';
import { ClenseNumeral } from '../../utils/PageDataPrepare';
import { fetchTesting_Categories } from '../../http/Data_API/Testing_Data_API';

import './AccountPageTestingBlock.css';

//  Перевод процента правильных ответов в оценку.
const PercentToMark = (percent) => {
    if (percent >= 90)
        return 5;
    else if (percent >= 80)
        return 4;
    else if (percent >= 70)
        return 3;
    else
        return 2;
};

//  Элемент в таблице с информацией о пройденном пользователем тестирвоании.
const UserTestingResultRow = ({ t, user, student }) => {

    const hasAnyTests = student?.tests?.length > 0;

    if (!user)
        return;

    if (!hasAnyTests)
        return <tr className='testing-results-table_row'>
            <td title={student.email}>{student.profile.firstName} {student.profile.lastName}</td>
            <td>{student.profile.faculty}</td>
            <td colSpan={4} style={{ textAlign: 'center' }}>
                не пройдено
            </td>
        </tr>;

    return student?.tests?.map( test => <tr key={test.id} className='testing-results-table_row'>
        <td title={student.email}>{student.profile.firstName} {student.profile.lastName}</td>
        <td>{student.profile.faculty}</td>
        <td>{test?.name?.[user.language]}</td>
        <td>{new Date(test.createdAt).toLocaleString()}</td>
        <td className='testing-results-table_correct'>
            {test?.correct}&nbsp;/&nbsp;{test?.questions?.length}
        </td>
        <td className='testing-results-table_mark'>
            <span>{PercentToMark(test?.correctPercent)}</span>
            <br />
            ({test?.correctPercent}%)
        </td>
    </tr>);
};

//  Блок на странице профиля с информацией обо всех тестах, которые были пройдены пользователями, входящими в состав университета этого пользователя.
const ControlledUsersPassedQuizzesBlock = ({ t, user, error, setError }) => {
    const [ filter, setFilter ] = useState({ display: null, results: 10, category: null, subcategory: null });
    const [ expandedSection, setExpandedSection ] = useState('display');
    const [ categories, setCategories ] = useState([]);
    const [ students, setStudents ] = useState([]);
    const [ search, setSearch ] = useState(null);

    //  Изменение какого-либо фильтра.
    const handleFiltersChange = (event) => {
        setFilter( p => ({
            ...p,
            [event.target.name]: event.target.value
        }) );
    };

    //  При смене выбранной категории - учесть, что может быть указана подкатегория.
    const handleCategoryChange = (event) => {
        event.stopPropagation();

        const [ categoryId, subcategoryId ] = event.target.value.split('|').map(Number);

        setFilter( p => ({
            ...p,
            category: categoryId,
            subcategory: subcategoryId,
        }) );
    };

    //  Поиск по ФИО студента.
    const handleSearchChange = (event) => {
        setSearch(event.target.value);
    };

    //  Обработка списка студентов с учётом введёного поискового запроса.
    const handleSearchFiltering = (value) => {
        if (!search || search === '')
            return true;

        const fullName = value?.profile?.firstName + ' ' + value?.profile?.lastName;
        if (fullName?.trim() === '')
            return false;

        return fullName.toLocaleLowerCase().includes(search.toLocaleLowerCase());
    };

    //  Запрос на экспорт оценок.
    const handleExport = (event) => {
        try
        {
            //  TODO:   отправить запрос на сервер, передав все параметры фильтрации (и поиска?) для формирования xlsx файла.
        }catch (error)
        {
            setError(error.message);
        }
    };

    useEffect( () => {
        fetchTesting_Categories().then( c => c?.error ? setError(c.error) : setCategories(c) );
        fetchStudentsTestingResults(filter?.category, filter?.subcategory, filter?.display, filter?.results).then( s => s?.error ? setError(s.error) : setStudents(s) );
    }, [ filter ] );

    return <div className='testing_results'>
        <div className='group'>
            <div className='heading'>{t('profile_student_quiz_results_title')} {user.profile.profile.moodle?.clientdescription}</div>
            <div>{t('profile_student_quiz_results_hint')}</div>
        </div>

        <form className='testing_results-filters' onChange={handleFiltersChange}>
            <div className='category-accordion group'>
                <div className='accordion-header' onClick={ e => setExpandedSection( p => p === 'display' ? null : 'display' ) }>
                    Параметры отображения
                    <span className='accordion-icon'>{expandedSection === 'display' ? '-' : '+'}</span>
                </div>
                <div className={ 'filters-content accordion-content' + (expandedSection === 'display' ? ' expanded' : '') }>
                    <div className='filters-content_element'>
                        <label>Попытки от</label>
                        <select name='display' defaultValue={filter?.display}>
                            <option value='all'>Всех</option>
                            <option value='onlygraded'>Тех, кто завершили тест</option>
                        </select>
                    </div>
                    {/* <div className='filters-content_element'>
                        <label>Результатов</label>
                        <input type='number' name='results' defaultValue={filter?.results} />
                    </div> */}
                    <div className='filters-content_element'>
                        <label>Категория</label>
                        <select name='category' onChange={handleCategoryChange}>
                            <option value=''>Любая</option>
                            {categories?.map( c => {
                                return <optgroup key={c.id} label={c['name_' + user.language]}>
                                    <option value={c.id}>{c['name_' + user.language]}</option>
                                    {c?.subcategories?.map( sc => <option key={sc.id} value={ sc.id.toString() + '|' + c.id.toString() }>{sc['name_' + user.language]}</option> )}
                                </optgroup>
                            })}
                        </select>
                    </div>
                </div>
            </div>
        </form>

        <div className='testing-results_actions'>
            <div>
                <input type='text' name='search' placeholder='Поиск' onChange={handleSearchChange} />
            </div>
            <div>
                <button disabled onClick={handleExport}>экспорт</button>
            </div>
        </div>

        <table className='testing-results_table table table-hover'>
            <thead>
                <tr>
                    <th>Фамилия / Имя / Отчество</th>
                    <th>Факультет/кафедра</th>
                    <th>Категория</th>
                    <th>Тест начат</th>
                    <th>Верных ответов</th>
                    <th>Оценка</th>
                </tr>
            </thead>
            <tbody>
                {students?.length === 0 && <tr>
                    <td colSpan={6} style={{ textAlign: 'center', padding: '4rem 0' }}>никого не найдено</td>
                </tr>}
                {students?.filter(handleSearchFiltering).map( s => <UserTestingResultRow key={s.id} t={t} user={user} student={s} /> )}
            </tbody>
        </table>
    </div>;
};

export default ControlledUsersPassedQuizzesBlock;